module.exports = __webpack_public_path__ + "static/img/testimonial-reg.89ad20d.png";


//////////////////
// WEBPACK FOOTER
// ./static/testimonial-reg.png
// module id = 2794
// module chunks = 1